
/**
 * Environment variables accessible to the client-side code
 * Note: In production, these should be set through proper deployment configurations
 */

// Validate Google Maps API key
const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';

if (!GOOGLE_MAPS_API_KEY && import.meta.env.PROD) {
  console.error('Google Maps API key is not configured. Please set VITE_GOOGLE_MAPS_API_KEY environment variable.');
}

export const env = {
  // Google Maps API key for address autocomplete and boundary verification
  // IMPORTANT: This API key MUST have the following APIs enabled:
  // - Maps JavaScript API
  // - Places API
  // - Geometry API
  // - Drawing API
  GOOGLE_MAPS_API_KEY,
  
  // Map center coordinates for Northwest Suburban Integration School District (NWSISD) area
  // These coordinates are centered on the approximate middle of the NWSISD district
  // which includes Brooklyn Center, Fridley, and parts of neighboring cities
  MAP_CENTER_LAT: 45.0902,
  MAP_CENTER_LNG: -93.3299,
  
  // Default map zoom level for district view
  // A higher zoom level (10-12) shows city-level detail
  MAP_DEFAULT_ZOOM: 10,
  
  // District boundary approximate bounding box
  // These coordinates define the min/max latitude and longitude of the NWSISD district
  // Based on actual geographic data for the district municipalities
  DISTRICT_MIN_LAT: 44.94,
  DISTRICT_MAX_LAT: 45.24,
  DISTRICT_MIN_LNG: -93.58,
  DISTRICT_MAX_LNG: -93.08,
  
  // Predefined district polygon points
  // This provides a fallback boundary when no custom boundary is uploaded
  // Represents approximate boundaries of the NWSISD district
  DISTRICT_DEFAULT_BOUNDARY: [
    [-93.4323, 45.1238], // Northwest - Osseo Area
    [-93.2839, 45.1430], // North - Anoka-Hennepin
    [-93.1890, 45.0902], // Northeast - Fridley 
    [-93.2070, 44.9901], // East - Brooklyn Center
    [-93.3452, 44.9731], // South - Robbinsdale
    [-93.4723, 45.0194], // Southwest - Wayzata
    [-93.4823, 45.0794], // West - Osseo Area
    [-93.4323, 45.1238]  // Back to start to close the polygon
  ]
};
